import React from "react";
import { Button } from "react-bootstrap";
import ListPage from "../Common/ListPage";
import "./Users.scss";
import { Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEdit,
    faTrash,
    faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Item from "../Common/Item";
import * as Yup from "yup";


interface Props {
    action: "list" | "add" | "edit";
}

const Channels: React.FC<Props> = ({ action }) => {

    const endpoint = "/api/channels/";

    const formFields = [
        {
            name: "label",
            type: "text",
            label: "Nom",
            validation: Yup.string().required("Vous devez renseigner le nom"),
        }
    ];

    const listFields = [
        {
            name: "label",
            label: "Nom",
            orderable: true,
        },
        
    ];

    // const searchFields = [
    //     {
    //         name: "id",
    //         label: "Nom",
    //         options: {
    //             source: "/api/channels/",
    //             identifier: "id",
    //             label: 'label',
    //             searchIsMulti: false,
    //         },
    //     },
    // ];

    const actions = [
        {
            name: "edit",
            label: "Modifier le canal",
            icon: <FontAwesomeIcon icon={faEdit} />,
            url: "/admin/channels/edit/:id",
        },
        {
            name: "delete",
            label: "Supprimer le canal",
            icon: <FontAwesomeIcon icon={faTrash} />,
            deleteMessage: {
                endpoint: endpoint,
                confirm: {
                    title: "Supprimer le canal",
                    message: "Êtes-vous sûr de vouloir supprimer ce canal?",
                },
                notificationMessage: "Le canal a été supprimé avec succès",
            },
        },
    ];


    return (
        <div>
            {action === "list" && (
                <div className="block" >

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h2>
                            <Trans>Liste des canaux</Trans>
                        </h2>

                        <div className="button-add-channel">
                            <Link to="/admin/channels/add">
                                <Button>
                                    <FontAwesomeIcon icon={faPlusCircle} /> Ajouter un canal
                                </Button>
                            </Link>
                        </div>
                    </div>

                    <ListPage
                        endpoint={endpoint}
                        fields={listFields}
                        actions={actions}
                        // searchFields={searchFields}
                    />
                </div>
            )}
            {action === "add" && (
                <Item
                    action="add"
                    endpoint={endpoint}
                    fields={formFields}
                    name="Ajouter un canal"
                />
            )}
            {action === "edit" && (
                <Item
                    action="edit"
                    endpoint={endpoint}
                    fields={formFields}
                    name="Modifier le canal"
                />
            )}
        </div>
    );
};

export default Channels;
